import { render, staticRenderFns } from "./FlyingRoomHotel.vue?vue&type=template&id=57a3b92b&scoped=true"
import script from "./FlyingRoomHotel.vue?vue&type=script&lang=js"
export * from "./FlyingRoomHotel.vue?vue&type=script&lang=js"
import style0 from "./FlyingRoomHotel.vue?vue&type=style&index=0&id=57a3b92b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a3b92b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a3b92b')) {
      api.createRecord('57a3b92b', component.options)
    } else {
      api.reload('57a3b92b', component.options)
    }
    module.hot.accept("./FlyingRoomHotel.vue?vue&type=template&id=57a3b92b&scoped=true", function () {
      api.rerender('57a3b92b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/FlyingRoomHotel.vue"
export default component.exports